import { Directive, Input, HostBinding } from '@angular/core';

/**
 * Applies Bazis background utility classes to the host element.
 *
 * Inputs:
 * - `bg: string` — Background name appended to `bazis-bg-{bg}`.
 *
 * Example:
 * ```html
 * <div bg="surface">Card</div>
 * ```
 */
@Directive({
    selector: '[bg]',
    standalone: true,
})
export class BackgroundDirective {
    /**
     * Background name used to form utility class `bazis-bg-{bg}`.
     */
    @Input() bg: string;

    /**
     * Applies background utility classes to the host.
     */
    @HostBinding('class') get getColorClass() {
        return this.bg
            ? {
                  'bh-bg': true,
                  [`bazis-bg-${this.bg}`]: true,
              }
            : null;
    }
}
